import { Alert, Badge, Button } from '@catering/ui';
import type { JSX } from 'react';

import type { QueuedSignature } from './signature-queue';

/** "Firma guardada, falta enviarla" for a waiting capture; the refusal message plus "Descartar" for a problem one. */
export function QueueItemStatus({
  item,
  onDismiss,
}: {
  item: QueuedSignature;
  onDismiss: (noteId: string) => void;
}): JSX.Element {
  if (item.state === 'pending') {
    return <Badge variant="warning">Firma guardada, falta enviarla</Badge>;
  }

  return (
    <Alert tone="danger">
      <span className="flex flex-col gap-2">
        <span>{item.problem?.message}</span>
        <Button variant="secondary" onClick={() => onDismiss(item.noteId)}>
          Descartar
        </Button>
      </span>
    </Alert>
  );
}
